export default "__VITE_ASSET__CBtNo8dv__"